import EditUser from './components/EditUserNew';
import { bindActionCreators } from 'redux';
import withRouter from 'react-router-dom/withRouter';
import get from 'lodash/get';
import has from 'lodash/has';
import {connect} from 'react-redux';

import {
  loadUser,
  updateUser,
  createUser,
  checkIfEmailTaken
} from '../../shared/redux/entities/actions';

import {
  getActiveAgencyUser
} from '../../shared/redux/selectors';

function mapStateToProps(state,props){
  const userId = props.match.params.userId,
    activeUser = getActiveAgencyUser(state),
    isProfile = props.match.path.includes('profile');

  return {
    isUpdate:!!userId,
    isCreate:props.match.path.includes('new'),
    isProfile:isProfile,
    userId:userId,
    activeUser:activeUser,
    needsLoading:!has(state,['entities','users',userId]),
    existingUser:isProfile ? activeUser : get(state,['entities','users',userId])
  };
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    loadUser,
    updateUser,
    createUser,
    checkIfEmailTaken
  },dispatch);
}

export default connect(mapStateToProps,mapDispatchToProps)(withRouter(EditUser));



// WEBPACK FOOTER //
// ./src/routes/EditUserNew/index.js